import { MicroFeedbackFieldData, MicroFeedbackType } from 'types/micro-feedback';

export const microFeedbackData: Record<MicroFeedbackType, MicroFeedbackFieldData> = {
	REPEAT_REIT_INVESTMENT: {
		subHeadline: 'What prompted you to invest with us today?',
		backButtonRedirect: `${process.env.VUE_APP_BASE_PATH}/account/overview`
	},
	REIT_INVESTMENT_CANCELLED: {
		subHeadline: 'Why did you cancel your order?',
		backButtonRedirect: `${process.env.VUE_APP_BASE_PATH}/account/transactions`
	},
	RECURRING_INVESTMENT_DISABLED: {
		subHeadline: 'Why did you disable Auto-Invest?',
		backButtonRedirect: `${process.env.VUE_APP_BASE_PATH}/account/investment-accounts`
	},
	LIQUIDATION_REQUEST_CANCELLED: {
		subHeadline: 'Why did you cancel your redemption request?',
		backButtonRedirect: `${process.env.VUE_APP_BASE_PATH}/account/transactions`
	},
	EMAIL_COMMUNICATION: {
		subHeadline: 'What did you think of this email?',
		backButtonRedirect: `${process.env.VUE_APP_BASE_PATH}/account/overview`
	},
	INVESTOR_UPDATE: {
		subHeadline: 'What did you think of this investor update?',
		backButtonRedirect: `${process.env.VUE_APP_BASE_PATH}/account/overview`
	},
	INVITATION_SENT: {
		subHeadline: 'What was the primary reason you invited someone to join Fundrise?',
		backButtonRedirect: `${process.env.VUE_APP_BASE_PATH}/invitation-program/landing`
	},
	RECURRING_INVESTMENT_PAUSED: {
		subHeadline: 'Why did you pause Auto-Invest?',
		backButtonRedirect: `${process.env.VUE_APP_BASE_PATH}/account/overview`
	},
	IRA_INITIAL_INVESTMENT: {
		subHeadline: 'How was your experience opening an IRA with Fundrise?',
		backButtonRedirect: `${process.env.VUE_APP_BASE_PATH}/account/overview`
	},
	REPEAT_IRA_INVESTMENT: {
		subHeadline: 'How was your experience investing through your IRA?',
		backButtonRedirect: `${process.env.VUE_APP_BASE_PATH}/account/overview`
	},
	INVESTOR_GOAL_DELETED: {
		subHeadline: 'Why did you delete your goal',
		backButtonRedirect: `${process.env.VUE_APP_BASE_PATH}/account/overview`
	},
	HISTORICAL_RETURNS_MODULE_MODAL: {
		subHeadline: 'What did you think of this content?',
		backButtonRedirect: `${process.env.VUE_APP_BASE_PATH}/account/overview`
	}
};
